import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../store/actions/userActions';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButton,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonThumbnail,
  IonLoading,
  IonFabButton,
  IonIcon,
  IonText,
  IonModal,
  IonInput,
  IonSelectOption,
  IonSelect
} from '@ionic/react';
import FloatingActionButton from '../components/FloatingActionButton';
import { add, pencilOutline } from 'ionicons/icons';

const Tab3: React.FC = (props: any) => {
  const { user, userDBInfo } = props;

  const [tryInstall, setTryInstall] = useState(false);
  const [ready, setReady] = useState(false);
  const [showSweepModal, setSweepShowModal] = useState(false);
  const [showDeliveryModal, setDeliveryShowModal] = useState(false);

  if (userDBInfo === null) {
    props.onsetUser(user);
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  const logoutWithRedirect = () => {
    localStorage.setItem('user', '');
    window.location.reload();
  };

  let deferredPrompt: any;
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    //show install button
    setReady(true);
  });

  const handleInstall = () => {
    setTryInstall(true);
    // Show the prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      deferredPrompt = null;
      setTryInstall(false);
    });
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Profile</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem class="ion-padding-top">
          <IonThumbnail slot="start" border-radius="0">
            <img
              src={userDBInfo.imageURL || 'assets/mosi-shop.png'}
              alt="item"
            />
          </IonThumbnail>
          <IonLabel>
            <h4>
              <b>
                <p>{userDBInfo.shopName || 'My Mosi Shop'}</p>
              </b>
            </h4>
            <h4>
              <p>{userDBInfo.shopDescription || 'no description'}</p>
            </h4>
            <h4>
              <p>{user.email}</p>
            </h4>
            <h4>
              <p>{userDBInfo.number}</p>
            </h4>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <h4>
              <b>
                <p>Address</p>
              </b>
            </h4>
            <h6>{userDBInfo.address || 'not provided'}</h6>
          </IonLabel>
        </IonItem>
        <IonItem class="ion-padding-bottom">
          <IonLabel>
            <h4>
              <b>
                Website
              </b>
            </h4>
            <h6>{userDBInfo.website || 'www.mosi.shop/davebooth'}</h6>
          </IonLabel>
        </IonItem>
        <IonList class="ion-padding-bottom">
          <IonListHeader>Settlement Account</IonListHeader>
          <IonItem>
            <IonThumbnail slot="start" border-radius="0">
              <img src="assets/mpesa.png" alt="item" />
            </IonThumbnail>
            <IonLabel>
              <h4>
                <b>
                  <p>Mpesa</p>
                </b>
              </h4>
              <h4>
                <p>{userDBInfo.number || 'not provided'}</p>
              </h4>
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel className="ion-text-center">
              <IonButton shape="round" color="light" onClick={() => setSweepShowModal(true)}>
                <IonIcon icon={add} />
              </IonButton>
            </IonLabel>
          </IonItem>
        </IonList>
        <IonList class="ion-padding-bottom">
          <IonListHeader>Delivery Options 
            {/*<IonButton size="small" color="dark" fill="outline">Add</IonButton>*/}
          </IonListHeader>
          <IonItem>
            <IonLabel>
              <h4>Inside CBD</h4>
              <h4>KES 0</h4>
            </IonLabel>
          </IonItem>         
          <IonItem lines="none">
            <IonLabel className="ion-text-center">
              <IonButton shape="round" color="light" onClick={() => setDeliveryShowModal(true)}><IonIcon icon={add} /></IonButton>
            </IonLabel>
          </IonItem>
        </IonList>
       
        <IonButton
          color="danger"
          expand="block"
          onClick={logoutWithRedirect}
          class="ion-margin-top"
        >
          log out
        </IonButton>

        <IonModal isOpen={showSweepModal} cssClass='my-custom-class'>
          <IonHeader>
            <IonToolbar color="dark">
              <IonTitle>Settlement Account</IonTitle>
            </IonToolbar>
          </IonHeader>
        <IonContent>
        <IonList>
          <img
              src="assets/sweep_accounts.svg"
              alt="logo"
              className="centered"
              style={{
                width: 250,
                marginTop: '5vh',
                marginBottom: '5vh',
                display: 'block',
              }}
            />
          <IonItem>
            <IonLabel>Payment Channel</IonLabel>
            <IonSelect placeholder="Select your preferred channel">
              <IonSelectOption value="mpesa">Mpesa</IonSelectOption>
            </IonSelect>
          </IonItem>          
          <IonItem>
            <IonLabel position="stacked">
              Mobile Number <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput type="number"></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Confirm Mobile Number <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput type="number"></IonInput>
          </IonItem>
          </IonList>
        </IonContent>
        <IonButton color="primary" onClick={() => {}}>Add</IonButton>
        <IonButton color="danger" onClick={() => setSweepShowModal(false)}>Cancel</IonButton>
      </IonModal>

      <IonModal isOpen={showDeliveryModal} cssClass='my-custom-class'>
          <IonHeader>
            <IonToolbar color="dark">
              <IonTitle>Add Delivery Option</IonTitle>
            </IonToolbar>
          </IonHeader>
        <IonContent>
        <IonList>
          <img
              src="assets/delivery.svg"
              alt="logo"
              className="centered"
              style={{
                width: 250,
                marginTop: '5vh',
                marginBottom: '5vh',
                display: 'block',
              }}
            />       
          <IonItem>
            <IonLabel position="stacked">
              Destination <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput type="text"></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">
              Amount <IonText color="danger">*</IonText>
            </IonLabel>
            <IonInput type="number"></IonInput>
          </IonItem>
          </IonList>
        </IonContent>
        <IonButton color="primary" onClick={() => {}}>Add</IonButton>
        <IonButton color="danger" onClick={() => setDeliveryShowModal(false)}>Cancel</IonButton>
      </IonModal>

      </IonContent>
      <FloatingActionButton children={'/editUser'} />
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.userReducer.user,
    userDBInfo: state.userReducer.userDbInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onsetUser: (payload: {}) => dispatch(actionCreator.setUser(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tab3);
